// Importa { createStore } en lugar de Vuex
import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
  state: {
    numeroCitas: 0,
    numeroAtenciones: 0,
    numeroInterconsultas: 0,
    numeroReferencias: 0,
  },
  mutations: {
    SET_NUMERO_CITAS(state, payload) {
      state.numeroCitas = payload;
    },
    SET_NUMERO_ATENCIONES(state, payload) {
      state.numeroAtenciones = payload;
    },
    SET_NUMERO_INTERCONSULTAS(state, payload) {
      state.numeroInterconsultas = payload;
    },
    SET_NUMERO_REFERENCIAS(state, payload) {
      state.numeroReferencias = payload;
    },
  },
  actions: {
    fetchNumeroCitas({ commit }) {
      axios.get(`http://localhost:8080/api/v1/vwcitas/estadocita/${window.sessionStorage.getItem("idEmpresa")}/PROGRAMADA`)
        .then(response => {
          commit('SET_NUMERO_CITAS', response.data.length);
        })
        .catch(error => {
          console.error('Error fetching número de citas:', error);
        });
    },
    fetchNumeroAtenciones({ commit }) {
      axios.get(`http://localhost:8080/api/v1/vwatencions/empresa-estadoatencion/${window.sessionStorage.getItem("idEmpresa")}/PENDIENTE`)
        .then(response => {
          commit('SET_NUMERO_ATENCIONES', response.data.length);
        })
        .catch(error => {
          console.error('Error fetching número de atenciones:', error);
        });
    },
    fetchNumeroInterconsultas({ commit }) {
      axios.get(`http://localhost:8080/api/v1/vwinterconsultas/idmedico/${window.sessionStorage.getItem("idMedico")}`)
        .then(response => {
          commit('SET_NUMERO_INTERCONSULTAS', response.data.length);
        })
        .catch(error => {
          console.error('Error fetching número de interconsultas:', error);
        });
    },
    fetchNumeroReferencias({ commit }) {
      axios.get(`http://localhost:8080/api/v1/vwreferencias/idmedico/${window.sessionStorage.getItem("idMedico")}`)
        .then(response => {
          commit('SET_NUMERO_REFERENCIAS', response.data.length);
        })
        .catch(error => {
          console.error('Error fetching número de referencias:', error);
        });
    },
  },
  getters: {
    numeroCitas: state => state.numeroCitas,
    numeroAtenciones: state => state.numeroAtenciones,
    numeroInterconsultas: state => state.numeroInterconsultas,
    numeroReferencias: state => state.numeroReferencias,
  }
});